// extracted by mini-css-extract-plugin
export default {"button":"L_Q4H","returnButton":"H0Uog"};